import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconMistral: FC<IconProps> = ({ size = 40, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2689_6786)">
      <path d="M7.49924 7.45834H12.4999V12.4575H7.49924V7.45834ZM27.4988 7.45834H32.5009V12.4575H27.4988V7.45834Z" fill="#FFD700" />
      <path d="M7.49924 12.4575H17.499V17.4581H7.5007L7.49924 12.4575ZM22.4997 12.4575H32.4994V17.4581H22.4997V12.4575Z" fill="#FFAF00" />
      <path d="M7.49924 17.4596H32.5009V22.4587H7.49924V17.4596Z" fill="#FF8205" />
      <path
        d="M7.49924 22.4587H12.4999V27.4579H7.49924V22.4587ZM17.5005 22.4587H22.5011V27.4579H17.5005V22.4587ZM27.4988 22.4587H32.5009V27.4579H27.4988V22.4587Z"
        fill="#FA500F"
      />
      <path d="M2.5 27.4579H17.5004V32.4585H2.5V27.4579ZM22.4996 27.4579H37.5V32.4585H22.4996V27.4579Z" fill="#E10500" />
    </g>
    <defs>
      <clipPath id="clip0_2689_6786">
        <rect width="35" height="35" fill="white" transform="translate(2.5 2.5)" />
      </clipPath>
    </defs>
  </svg>
);

IconMistral.defaultProps = defaultIconProps;
